import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { SortingRule } from 'react-table';

import {
  FeedbackDishGroupReport,
  FeedbackDishGroupReportMenuItem,
} from 'http/Api/Feedback/types';
import FeedbackDishGroupsReportStore from 'stores/Report/Feedback/FeedbackDishGroupsReportStore';
import FeedbackDishGroupsReportForm from 'stores/Forms/Reports/Feedback/FeedbackDishGroupsReportForm';
import ModalStore from 'stores/ModalStore';

import FeedbackMenuItemAnalyticsModal from 'components/Modals/Feedback/MenuItemAnalytics/FeedbackMenuItemAnalyticsModal';
import Table from 'components/Table/Table';

import config from './columnsConfig';
import style from './FeedbackDishGroupsReportTab.module.scss';

interface Props {
  report: FeedbackDishGroupReport;
  store: FeedbackDishGroupsReportStore;
  form: FeedbackDishGroupsReportForm;
  tableStyle?: string;
}

@observer
class ReportTable extends Component<Props> {
  @observable styles = new Map();
  private _defaultSorted = [{ id: 'title', desc: true }];

  handleResize = newResized => {
    newResized.forEach(it => {
      this.styles.set(it.id, it.value);
    });
  };

  handleSort = (
    newSorted: SortingRule[],
    column: any,
    additive: boolean,
  ): void => {
    if (newSorted.length) {
      this.props.store.changeSortProperty({
        id: newSorted[0].id,
        desc: newSorted[0].desc,
      });
    } else {
      this.props.store.changeSortProperty(null);
    }
  };

  handleMenuItemAnalyticsClick = (
    menuItem: FeedbackDishGroupReportMenuItem,
  ) => {
    const { startDateParam, endDateParam } = this.props.form;

    ModalStore.showModal(FeedbackMenuItemAnalyticsModal, {
      menuItem,
      startDate: startDateParam,
      endDate: endDateParam,
    });
  };

  render() {
    const { report, tableStyle } = this.props;

    return (
      <>
        <h3 className={style.table__title}>{report.title}</h3>
        <div className={style.table__wrapper}>
          <Table
            data={report.menuItems}
            defaultSorted={this._defaultSorted}
            className={classNames(style.table, tableStyle)}
            columns={config(this.handleMenuItemAnalyticsClick)}
            onResizedChange={this.handleResize}
            onSortedChange={this.handleSort}
          />
        </div>
      </>
    );
  }
}

export default ReportTable;
